import { createReducer, on } from "@ngrx/store";

import { eventDataModel } from "@sports-models/index";
import * as SportsbookActions from "../../../stores/sportsbook/sportsbook.actions";

export const initialState: eventDataModel = {
  eventMainCategories: [],
  eventMarkesCategories: [],
  games: [],
  specialMarkets: null,
  leagueName: "",
  event: null,
  parentId: "",
  selectedEventMainCategory: null,
  selectedMarketsCategory: null,
  markets: null,
  betsCategories: null,
};

export const SportsbookEventReducer = createReducer(
  initialState,
  // EventPage
  on(SportsbookActions.setEventGames, (state, eventData) => ({
    ...state,
    ...eventData,
  })),
  on(SportsbookActions.clearEvent, (state) => ({
    ...state,
    ...initialState,
  })),
  on(SportsbookActions.setEventGamesNoLive, (state, { type, ...payload }) => {
    return {
      ...state,
      markets: payload.markets,
    };
  }),
);
